import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Button } from '../StyledComponents';

import { colorOptions } from '../constants/formSetup';

const SelectColor = ({ handleChange, nextStep, variant }) => {
  const [selectedColor, setSelectedColor] = useState([]);

  const handleSelectColor = colorName => {
    if (colorName === 'blank') return;
    let newColors;
    if (selectedColor.includes(colorName)) {
      newColors = selectedColor.filter(color => color !== colorName);
      setSelectedColor(newColors);
    } else {
      if (selectedColor.length === 5) return;
      newColors = [...selectedColor, colorName];
      setSelectedColor(newColors);
    }

    handleChange({
      color: newColors.join(', '),
    });
  };

  return (
    <StyledFormStep
      key="color-select"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.25 }}
    >
      <h2>Select Your Colors</h2>
      {variant === 'boa' ? (
        <p>(Select at least two colors and a max of five colors)</p>
      ) : (
        <p>(Select up to five colors in order of importance)</p>
      )}

      <div className="color-container">
        <div className="header-container">
          <h1>PRIMARY COLOR RANGE</h1>
        </div>
        <div className="color-boxes">
          {colorOptions.map(color => (
            <div
              className={`color-box ${color.name} ${
                selectedColor.includes(color.name) && 'selected'
              } ${selectedColor.length === 5 && 'disabled'} ${
                color.darkText && 'dark-text'
              }`}
              style={{ backgroundColor: color.hex }}
              key={color.name}
              onClick={() => handleSelectColor(color.name)}
            >
              {selectedColor.includes(color.name) && (
                <span className="order-number">
                  #{selectedColor.indexOf(color.name) + 1}
                </span>
              )}
              <h4>{color.name}</h4>
            </div>
          ))}
          <img src="/triton-logo.png" alt="Team Triton Logo" />
        </div>
      </div>

      <Button onClick={nextStep} disabled={(variant === 'boa' && selectedColor.length < 2) || selectedColor.length === 0}>
        Next Step
      </Button>
    </StyledFormStep>
  );
};

const StyledFormStep = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 50px 20px 100px;

  h1 {
    letter-spacing: 4px;
    color: #d91001;
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    background: black;
    margin: 0;
    padding: 0.8rem;
    font-size: 78px;
    font-weight: 400;

    @media (max-width: 768px) {
      font-size: 38px;
    }
  }

  h2 {
    margin: 0 !important;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
  }

  p {
    font-weight: 100;
    margin: 8px auto 33px;
  }

  img {
    width: 100%;
    max-width: 800px;
    margin-bottom: 1rem;
  }

  .color-container {
    max-width: 800px;
    margin: 0 auto 33px;
  }

  .color-boxes {
    display: flex;
    flex-wrap: wrap;
    background: black;

    .color-box {
      position: relative;
      width: 16.66666667%;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      color: white;
      cursor: pointer;
      padding: 5px;

      span.order-number {
        position: absolute;
        top: 4px;
        left: 4px;
      }

      h4 {
        margin: 0;
        text-align: center;
      }

      &.selected {
        border: 4px solid lime;

        &.disabled {
          cursor: pointer;
          opacity: 1;
        }
      }

      &.dark-text {
        color: black;
      }

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      @media (max-width: 768px) {
        width: 33.333333%;
      }
    }

    img {
      height: 300px;
      width: auto;
      max-width: 100%;
      margin: auto;
      padding: 20px;

      @media (max-width: 768px) {
        height: auto;
        width: 100%;
      }
    }
  }
`;

export default SelectColor;
